import React from "react";
import { useNavigate } from "react-router-dom";

function ThankYou() {

  const navigate = useNavigate();

  return (
    <div style={{
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      textAlign: "center"
    }}>
      <h1>✅ Message Sent Successfully</h1>
      <p>Thank you for reaching out. I’ll get back to you soon.</p>

      <button
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          cursor: "pointer"
        }}
        onClick={() => navigate("/")}
      >
        Back to Home
      </button>
    </div>
  );
}

export default ThankYou;
